module.exports = __webpack_public_path__ + "img/独活.3ad51cb4.jpg";